import axios from 'axios';
import { TASK_VIEWER_BACKEND_API_URL } from 'services/constants';
import { TasksFilterBody, TasksStatusResponseBody, TaskViewerConfig } from 'types/Tasks';
import { getHostBaseUrl } from 'utils/browserUtil';

export const jbHeaders = {
  'Content-Type': 'application/json',
};

const axiosInstance = axios.create({ baseURL: getHostBaseUrl(), withCredentials: true });

const getFeaturesAvailability = async (): Promise<TaskViewerConfig> => {
  const response = await axiosInstance.get(`${TASK_VIEWER_BACKEND_API_URL}/features-availability`);
  return response.data;
};

const createTasksFilterBody = (
  includeCompleted: boolean,
  brNumber: string,
  caseId: string | null,
  offset?: number,
  limit?: number,
  sortBy?: string,
  sortDirection?: string,
) => ({
  offset: offset,
  includeCompleted: includeCompleted,
  limit: limit,
  sortBy: sortBy,
  sortDirection: sortDirection,
  caseId: caseId,
  filter: {
    brNumber: brNumber,
  },
});

const getTasksStatusRequest = async (request: TasksFilterBody): Promise<TasksStatusResponseBody> => {
  const response = await axiosInstance.post(`${TASK_VIEWER_BACKEND_API_URL}/v1/tasks/status`, request, {
    headers: jbHeaders,
  });
  return response.data;
};

const taskViewerService = {
  getFeaturesAvailability,
  getTasksStatusRequest,
  createTasksFilterBody,
};
export default taskViewerService;
